import React from 'react';
import * as styles from './styles.module.scss';
import CategoryLinksList from 'components/UI/CategoryLinksList';

const Aside = ({ data }) => (
  <div className={styles.aside}>
    <div className={styles.aside_inner}>
      <div className={styles.aside_links}>
        <CategoryLinksList title="Categories" list={data.categoriesCommon} />
      </div>
      <div className={styles.aside_links}>
        <CategoryLinksList
          title="Popular"
          type="red"
          list={data.categoriesPopular}
        />
      </div>
    </div>
  </div>
);

export default Aside;
